import {FilterItemDto} from "./misc";

export const countriesList: FilterItemDto[] = [
  {id: 'US', name: 'US', value: 'US', icon: {name: '', type: 'fas'}, class: 'bg-red-400 hover:bg-red-500 text-white'},
  {id: 'GB', name: 'GB', value: 'GB', icon: {name: '', type: 'fas'}, class: 'bg-blue-400 hover:bg-blue-500 text-white'},
  {id: 'IE', name: 'IE', value: 'IE', icon: {name: '', type: 'fas'}, class: 'bg-emerald-400 hover:bg-emerald-500 text-white'},
];
